import React from 'react';
import { SignupData } from '../../../pages/SignupPage';
interface PlayerFormProps {
  updateDetails: (details: any) => void;
  data: SignupData;
}
const PlayerForm: React.FC<PlayerFormProps> = ({
  updateDetails,
  data
}) => {
  const positions = {
    football: ['Goalkeeper', 'Defender', 'Midfielder', 'Forward'],
    basketball: ['Point Guard', 'Shooting Guard', 'Small Forward', 'Power Forward', 'Center'],
    baseball: ['Pitcher', 'Catcher', 'Infielder', 'Outfielder'],
    tennis: ['Singles', 'Doubles']
    // Add positions for other sports
  };
  const sportPositions = positions[data.sport as keyof typeof positions] || [];
  return <div className="space-y-4" data-id="element-139">
      <div data-id="element-140">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-141">
          Position
        </label>
        <select className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" value={data.profileDetails?.position || ''} onChange={e => updateDetails({
        position: e.target.value
      })} data-id="element-142">
          <option value="" data-id="element-143">Select your position</option>
          {sportPositions.map(position => <option key={position} value={position} data-id="element-144">
              {position}
            </option>)}
        </select>
      </div>
      
      <div className="grid grid-cols-2 gap-4" data-id="element-145">
        <div data-id="element-146">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-147">
            Height
          </label>
          <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. 6'2&quot; or 188cm" value={data.profileDetails?.height || ''} onChange={e => updateDetails({
          height: e.target.value
        })} data-id="element-148" />
        </div>
        <div data-id="element-149">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-150">
            Weight
          </label>
          <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. 175lbs or 80kg" value={data.profileDetails?.weight || ''} onChange={e => updateDetails({
          weight: e.target.value
        })} data-id="element-151" />
        </div>
      </div>
      
      <div data-id="element-152">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-153">
          Dominant {data.sport === 'football' ? 'Foot' : 'Hand'}
        </label>
        <select className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" value={data.profileDetails?.dominantSide || ''} onChange={e => updateDetails({
        dominantSide: e.target.value
      })} data-id="element-154">
          <option value="" data-id="element-155">Select</option>
          <option value="Right" data-id="element-156">Right</option>
          <option value="Left" data-id="element-157">Left</option>
          <option value="Both" data-id="element-158">Both</option>
        </select>
      </div>
      
      <div data-id="element-159">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-160">
          Years of Experience
        </label>
        <input type="number" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. 5" value={data.profileDetails?.experience || ''} onChange={e => updateDetails({
        experience: e.target.value
      })} data-id="element-161" />
      </div>
      
      <div data-id="element-162">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-163">
          Current Team (if applicable)
        </label>
        <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. Real Madrid" value={data.profileDetails?.currentTeam || ''} onChange={e => updateDetails({
        currentTeam: e.target.value
      })} data-id="element-164" />
      </div>
    </div>;
};
export default PlayerForm;